<template>
    <div id="ficheClient">
        <b-row class="backInfoMain2">

            <menuSave 
                :msg="sendMsg" 
                newBtn 
                :btnSaveDisabled="checkAllField" 
                @new="menuNew()" 
                saveBtn 
                @save="menuSave()" 
                :deleteBtn="checkDeleteBtn"
                @delete="menuDelete(activeObj.id)"
                :msgText="sendMsg2"
                :msgType="getTheme.primary">
            </menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <s-itemList 
                    v-if="clientAccountList"
                    :content="clientAccountList" 
                    :returnValue.sync="activeObj"
                    activeField="isActive" 
                    :selectedItems="activeObj"
                    multiColonne
                    :fields="fields"
                    @getRowdDetail="getRowdDetail"
                    >
                </s-itemList>
                
            </b-col>
            <!--Fin section de gauche-->
            
<!--****************************************************************************************************************************************************************-->
            
            <!--Section du centre-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">


                <!--SOLDE DU COMPTE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_SoldeDuCompte')}}</div>
                            <div class="itemContain">
                                SOLDE $$$

                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--INFORMATIONS-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Informations')}}</div>
                            <div class="itemContain">
                                <!-- Société / Particulier -->
                                <s-duoSelector style="margin-left: -15px" :text1="$t('cc_Societe')" :text2="$t('cc_Particular')" invertTrueFalse :value="activeObj.isCompany" :returnValue.sync="activeObj.isCompany"></s-duoSelector>
                                <!-- Numéro du client -->
                                <s-input id = "numero" name="numero" type="text" maxlength="40" class="" :placeholder="$t('cc_NumeroDuClient')" v-model="activeObj.clientNumber" :state="isValid(activeObj.clientNumber)"></s-input>
                                <!-- Nom de la société / Nom du particulier -->
                                <s-input id = "nom" name="nom" type="text" maxlength="40" class="MargeTop5" :placeholder="!activeObj.isCompany ? $t('cc_Nom') : $t('cc_Societe')" v-model="activeObj.clientName" :state="isValid(activeObj.clientName)"></s-input>
                                <!-- Personne contact -->
                                <s-input v-if="activeObj.isCompany" id = "contact" name="contact" type="text" maxlength="40" class="MargeTop5" :placeholder="$t('cc_PersonneContact')" v-capitalize v-model="activeObj.contact"></s-input>
                                <!-- Adresses -->
                                <tabsAddress :parentId="activeObj.id" :addressList="activeObj.addressList" @updateAddress="updateAddress" @saveNewAddress="saveNewAddress" @removeAdress="removeAdress" />

                                <b-row>
                                    <b-col lg="6" xl="6" xs="3" sm="3" md="6">
                                        <!-- Télephone -->
                                        <s-input id = "tel1" name="tel1" type="text" maxlength="15" class="MargeTop15" :placeholder="$t('cc_Telephone')" v-mask="'(999) 999 9999'"  v-model="activeObj.tel1" :state="isValid(activeObj.tel1)"></s-input>
                                    </b-col>
                                    <b-col lg="6" xl="6" xs="3" sm="3" md="6">
                                        <!-- Extension -->
                                        <s-input id = "tel1Ext" name="tel1Ext" type="text" maxlength="10" class="MargeTop15" :placeholder="$t('cc_Ext')" v-model="activeObj.tel1Ext"></s-input>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="6" xl="6" xs="3" sm="3" md="6">
                                        <!-- Fax / autre -->
                                        <s-input id = "tel3" name="tel3" type="text" maxlength="15" class="MargeTop5" :placeholder="$t('cc_FaxAutre')" v-model="activeObj.tel3"></s-input>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col lg="6" xl="6" xs="3" sm="3" md="6">
                                        <!-- Cellulaire et envoi SMS -->
                                        <s-input-check class="MargeTop15" 
                                            id = "tel2" 
                                            name="tel2" 
                                            type="tel" 
                                            :maxlength="100" 
                                            :placeholder="$t('cc_Cellulaire')" 
                                            :inpuMask="'(999) 999 9999'"
                                            :isInputState="false"
                                            :value.sync="activeObj.tel2" 
                                            :checked.sync="activeObj.isSMSEnabled" 
                                            :checklabel="$t('cc_SMS')"
                                        ></s-input-check>
                                    </b-col>
                                    <b-col lg="6" xl="6" xs="3" sm="3" md="6">
                                        <!-- Courriel et envoi courriel -->
                                        <s-input-check class="MargeTop15"
                                            id="web" 
                                            name="web" 
                                            type="email"
                                            :maxlength="100"
                                            :placeholder="$t('cc_Courriel')" 
                                            :isInputState="true"
                                            :value.sync="activeObj.email" 
                                            :checked.sync="activeObj.isSendEmailEnabled" 
                                            :checklabel="$t('cc_SendEmail')"
                                        ></s-input-check>
                                    </b-col>
                                </b-row>
                                
                                <!-- Site web -->
                                <s-input id="web" name="web" type="text" :maxlength="100" class="MargeTop15" :placeholder="$t('cc_SiteWeb')" v-model="activeObj.webSite"></s-input>

                                
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--CONTACT-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Contact')}}</div>
                            <div class="itemContain txtMain">
                                <tabsContact type="clientContacts" :contactList.sync="activeObj.contactList" @saveNewContact="saveNewContact" @removeContact="removeContact" @updateContact="updateContact" @insertContact="insertContact"/>
                            </div>
                        </div>
                    </b-col>
                </b-row>


            </b-col>
            <!--FIN - Section de droite-->

            <!--Section de droite-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">

                <!--OPTIONS-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Options')}}</div>
                            <div class="itemContain txtMain">
                                   
                                <!-- Groupe client -->
                                <subElementSelector 
                                    v-if="clientGroupList"
                                    class="convertList MargeBottom15"
                                    saveValue="groupName"
                                    :apiAdd1="urlClientGroup" 
                                    showField="groupName" 
                                    returnField="id" 
                                    :content="clientGroupList"
                                    :returnAddValue.sync="clientGroupList"
                                    name= "Groupe" 
                                    addLength="40"
                                    :title="$t('cc_GroupeDeClient')" 
                                    :value="activeObj.clientGroupId" 
                                    :returnValue.sync="activeObj.clientGroupId" 
                                    :selectedItems="activeObj.clientGroupId">
                                </subElementSelector>

                                <!--Terme de paiement-->
                                <b-row align-v="center">
                                    <b-col cols="4">{{$t('cc_TermeDePaiement')}}</b-col>
                                    <b-col cols="4" xl="3"><b-form-input class="mmQte" id="terme" name="terme" type="number" min="0" max="999" v-model="activeObj.term"></b-form-input></b-col>
                                    <b-col cols="3">{{$t('cc_Jours')}}</b-col>
                                </b-row>
                                
                                <!--Ajustement de solde-->
                                <b-row align-v="center">
                                    <b-col cols="4">{{$t('cc_AjustementDeSolde')}}</b-col>
                                    <b-col cols="4" xl="3"><b-form-input class="mmQte" id="ajustSolde" name="ajustSolde" type="number" min="-999" max="999" v-model="ajustSolde"></b-form-input></b-col>
                                    <b-col cols="3"><b-button class="MargeTop5">{{$t('cc_Ajuster')}}</b-button></b-col>
                                </b-row>
                                <!--Solde sur facture-->
                                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="activeObj.isViewBalance">{{$t('cc_AfficherSoldeSurFacture')}}</b-form-checkbox>
                                
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--Crédit-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Credit')}}</div>
                            <div class="itemContain txtMain">
                                   
                                <!--No credit-->
                                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="activeObj.noCredit">{{$t('cc_AucunCredit')}}</b-form-checkbox>
                                <!--Unlimited credit-->
                                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="activeObj.unlimitedLimit">{{$t('cc_CreditIllimite')}}</b-form-checkbox>
                                <!--Limite de crédit-->
                                <b-row align-v="center">
                                    <b-col cols="4">{{$t('cc_LimiteDeCredit')}}</b-col>
                                    <b-col cols="4" xl="3"><b-form-input class="mmQte" id="limite" name="limite" type="number" min="0" max="999" v-model="activeObj.creditLimit"></b-form-input></b-col>
                                    <b-col cols="3">$</b-col>
                                </b-row>
                                
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--PRIX-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Prix')}}</div>
                            <div class="itemContain txtMain">
                                <!-- Niveau de prix -->
                                <oComboFix name="niveauPrix" :content="getCombo.cboNiveauPrix" :title="$t('cc_NiveauDePrix')" :value.sync="activeObj.priceLevel"></oComboFix>
                                <b-row>
                                    <s-currencyInput class="Commission" prepend="+" append="%" id="addPrix" name="addPrix" v-model="activeObj.percentAdd"></s-currencyInput>
                                </b-row>

                                <!-- Escompte -->
                                <comboSelector 
                                    v-if="escompteList"
                                    class="txtPrincipal" 
                                    showField="discountName" 
                                    returnField="id" 
                                    :content="escompteList" 
                                    name= "escompte" 
                                    :title="$t('cc_Escompte')" 
                                    :value="activeObj.discountId" 
                                    :returnValue.sync="activeObj.discountId" 
                                    :selectedItems="activeObj.discountId">
                                </comboSelector>

                                <!-- Ignorer les autres prix -->
                                <b-form-checkbox switch class="MargeTop5" :size="chkSize" v-model="activeObj.isIgnoreOtherPrice">{{$t('cc_IgnorerLesAutresPrix')}}</b-form-checkbox>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--NOTE-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Note')}}</div>
                            <div class="itemContain">
                                <b-form-textarea
                                    id="Note"
                                    v-model="activeObj.note"
                                    :placeholder="$t('cc_Note')"
                                    rows="4"
                                    max-rows="4"
                                    maxlength="255"
                                    style="margin-top: 5px">
                                </b-form-textarea>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--COMMISSION-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cc_Commission')}}</div>
                            <div class="itemContain">
                                <b-row align-v="center">
                                    <s-currencyInput class="Commission" append="$" id="txtCommissionA" name="txtCommissionA" min="0" max="9999" v-model="activeObj.commissionCash"></s-currencyInput>
                                </b-row>
                                <b-row align-v="center">
                                    <s-currencyInput class="Commission" append="%" id="txtCommissionP" name="txtCommissionP" min="0" max="100" step="0.5" v-model="activeObj.commissionPercent"></s-currencyInput>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <!--FIN - Section de droite-->
        </b-row>
    </div>
</template>

<script>

import {mapGetters} from 'vuex'

import mapGetter from '@/mixins/getters.js'
//import {bus} from '@/main.js'

import menuSave from '@/components/general/s-menuSave/s-menuSave.vue'
import comboSelector from '@/components/communs/s-comboSelector/s-comboSelector.vue'
import subElementSelector from '@/components/communs/s-subElementSelector/s-subElementSelector.vue'
import oComboFix from '@/components/communs/s-comboFix/s-comboFix.vue'
import tabsContact from '@/components/communs/s-tabsContact/s-tabsContact.vue'
import tabsAddress from '@/components/communs/s-tabsAddress/s-tabsAddress.vue'
import {dataService} from '@/services'
import store from '@/store'
import SocketioService from '@/plugins/socket/socketio.service.js'
var _ = require('lodash');

export default{
    name: "ficheClient",
    mixins:[mapGetter],
    components: {
        menuSave,
        comboSelector,
        subElementSelector,
        oComboFix,
        tabsAddress,
        tabsContact,
    },
    data() {
        return{
            fields:[
                {
                colName: "id",
                label: "id",
                show: false,
                },
                {
                colName: "clientNumber",
                label: this.$i18n.t('cc_Numero'),
                show: true,
                color: true
                },
                {
                colName: "clientName",
                label: this.$i18n.t('cc_Nom'),
                show: true,
                },
            ], 
            urlClientGroup: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiClientGroup,
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            sendMsg2: 'vide', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            //fromApi: null, //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            ajustSolde: 0,
            activeObj:{}, //Créé à l'ouverture à partir du modèle vide dans l'api
            originalObj : {},
            totalCount : 0,
            limitCount: 200,
            clientAccountList : [],
            escompteList : [],
            clientGroupList : []
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        /**
         * charge les données en fonction des limites start et end
         * @param {Object} params - start et end
         */
        onFetchNext(params) {
            dataService.getPaginatedClientAccountList(params.start, params.end)
            .then(response => {
                if(response.statusText == 'OK') {
                    let clientAccountData = response.data;
                    this.clientList.push(...clientAccountData.data.client)
                    this.totalCount = this.clientList.length
                }
            })
            .catch(error =>{
                console.log(error);
                alert('clientAccountService.getList Error : '+ error);
            });
        },
        /**
         * Ouvre la route 
         * @param {string} link - la route
         */
        pushto(link) {
            this.$router.push(link)
        },
        /**
         * Reinitialise tous les champs de la fiche client
         */
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.originalObj = this.$CObj(this.activeObj)
            this.ajustSolde = 0;
            //bus.$emit('initContacts', {id:this.activeObj.id, contactList : this.activeObj.contactList});
        },
        /**
         * Crée un nouveau fiche client vide
         */
        menuNew(){
            this.resetAll()
        },
        /**
         * Charge les données des clients 
         */
        loadApi() {
            this.sendMsg = '4'
            dataService.getClientAccountList()
            .then(response => {
                if(response.statusText == 'OK')
                {
                    this.sendMsg = ''
                    let data = response.data.data;
                    let addons = response.data.addons;

                    this.clientAccountList = this.$CObj(data.client)
                    this.clientGroupList = this.$CObj(data.clientGroupe)
                    this.escompteList = this.$CObj(data.escompte)
                    
                    this.InitialState = this.$CObj(addons.classes.client)
                    this.activeObj = this.$CObj(this.InitialState)
                    this.originalObj = this.$CObj(this.InitialState)

                }
            })
            .catch(error =>{
                this.sendMsg = ''
                console.log(error);
            })

            /*
            if(this.payload?.length == 0) {
                //Charger les contacts depuis le serveur si ils ne sont pas présent locallement
                this.sendMsg = '4'
                //Retourne le total des données, necessaire pour construire les boutons de la pagination
                dataService.getCountClientAccount()
                .then( total =>{
                    this.totalCount = total
                    //Retourne le premier lot de données de 0 à limitcount nombre de lignes
                    dataService.getPaginatedClientAccountList(0, this.limitCount)
                    .then(response => {
                        if(response.statusText == 'OK') {
                            this.sendMsg = ''
                            let clientAccountData = response.data;
                            this.clientList.push(...clientAccountData.data.client)

                            this.activeObj = this.$CObj(clientAccountData.addons.classes.client)
                            this.InitialState = this.$CObj(this.activeObj)
                        }
                    })
                    .catch(error =>{
                        console.log(error);
                        alert('getPaginatedClientAccountList Error : '+ error);
                    });

                })
                .catch((error) => { alert('loadApi '+ error)})

            } else {
                //Les données chargées depuis le localStorage
                this.limitCount = this.clientList?.length
                this.InitialState = this.$CObj(this.payload.addons.classes.client)
                this.activeObj = this.$CObj(this.InitialState)
                this.originalObj = this.$CObj(this.activeObj)
            }
            */
        },
        /**
         * Sauvegarde la fiche client
         */
        menuSave(){
            let t = this.activeObj
            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                this.sendMsg = '-'
                dataService.addClientAccount(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg2 ='add OK';

                        //this.loadApi();

                        const newAccount = response.data.data
                        SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'clients', payload: newAccount});
                        this.clientList.unshift(newAccount)                        
                        this.resetAll()
                        this.sendMsg = ''
                            
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if(error.data.data == "") {
                        this.sendMsg2 = error.data.addons.errorFr;
                    } else {
                        this.sendMsg2 = error;
                    }
                    this.sendMsg = ''
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                this.sendMsg = '-'
                dataService.updateClientAccount(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            this.sendMsg2 ='update OK';
                            const updatedAccount = response.data.data
                            SocketioService.getSocket().emit('afterUpdate', {action: 'afterUpdate', storeName:'clients', payload: updatedAccount});
                            this.clientAccountList = this.clientAccountList.map(acc => {
                                if(acc.id == updatedAccount.id)  Object.assign(acc, updatedAccount) ;
                                return acc;
                            });

                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = ''
                    this.sendMsg2 = error;
                });
            }
            setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        /**
         * Désactive la fiche client
         * @param {int} id - id du client
         */
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    dataService.deleteClientAccount(id)
                    .then((response) => {
                        this.sendMsg = ''
                        console.log(response.data);
                        SocketioService.getSocket().emit('afterDelete', {action: 'afterDelete', storeName:'clients', payload: {id:id, isActive:false}});
                        this.clientAccountList = this.clientAccountList.map(acc => {
                            if(acc.id == id)  acc.isActive = !acc.isActive;
                            return acc;
                        });
                        this.resetAll()
                    })
                    .catch((error) => {
                        this.sendMsg = '';
                        console.log(error);
                    });
                }
        },
        /**
         * Retourne les détails du client 
         * @param {int} id - id du client
         */
        getRowdDetail(id)
        {

            this.sendMsg = '-'
            dataService.getClientAccount(id)
            .then((response) => {
                if(response.statusText == 'OK') {
                    let data = response.data.data;
                    this.activeObj = data[0]
                    this.sendMsg2 ='getClientAccount OK';
                    this.originalObj = this.$CObj(this.activeObj)
                    this.InitialState = this.$CObj(response.data.addons.classes[0])
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = ''
                console.log(error);
                if(error.data.data == "") {
                    this.sendMsg2 = error.data.addons.errorFr;
                }
            });



            /*
            this.sendMsg = '-'
            let client = this.clientList.find(c => typeof c !== 'undefined' && c.id == id);
            
            if(client)
            {
                this.activeObj = this.$CObj(client)
                this.sendMsg2 ='getClient OK';
                this.originalObj = this.$CObj(this.activeObj)
                this.InitialState = this.$CObj(this.payload.addons.classes.client)

                bus.$emit('initAddresses', {id:this.activeObj.id, addressList : this.activeObj.addressList});

                bus.$emit('initContacts', {id:this.activeObj.id, contactList : this.activeObj.contactList});
            }
            this.sendMsg = ''
            */

            /*
            this.sendMsg = '-'
            dataService.getClientAccount(id)
            .then((response) => {
                if(response.statusText == 'OK')
                {
                    if(response.data)
                    {
                        let data = response.data.data;
                        this.activeObj = data[0]
                        this.sendMsg2 ='getClientAccount OK';
                        this.originalObj = this.$CObj(this.activeObj)

                        bus.$emit('initAddresses', {id:this.activeObj.id, addressList : this.activeObj.addressList});

                        bus.$emit('initContacts', {id:this.activeObj.id, contactList : this.activeObj.contactList});
                    }
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = ''
                console.log(error);
                if(error.data.data == "") {
                    this.sendMsg2 = error.data.addons.errorFr;
                }
            });
            */
        },

        /**
         * Enregistre les modifications de l'adresse
         * @param {Object} params -  adresse du client
         */
        updateAddress(params) {
            let address = params.address;
            if(this.activeObj.id > 0) {
                dataService.updateClientAccountAddress(this.activeObj.id, address)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        let addressList = response.data.data.addressList
                        this.activeObj.addressList = this.$CObj(addressList);
                        this.sendMsg2 ='Update addresse OK';
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            } else { //Modifier une addresse en mode ajout de client
                if(this.activeObj.addressList[0].id != 0 && this.activeObj.addressList[0].label != '') {
                    this.activeObj.addressList.unshift(this.$CObj(this.InitialState.addressList[0]))
                }
            }
            
        },
        /**
         * Enregistre une nouvelle adresse
         * @param {Object} params -  adresse du client
         */
        saveNewAddress(params){
            let newAddress = params.newAddress;
            if(this.activeObj.id > 0) {
                dataService.addClientAccountAddress(this.activeObj.id, newAddress)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        let addressList = response.data.data.addressList
                        this.activeObj.addressList = this.$CObj(addressList);
                        this.sendMsg2 ='Save addresse OK';
                    }
                })
                .catch(error => {
                    this.sendMsg2 = error;
                });
            } else { //Ajouter une addresse en mode ajout de client
                this.activeObj.addressList.unshift(this.$CObj(this.InitialState.addressList[0]));
            }
            
        },
        /**
         * Désactive l'adresse
         * @param {Object} params - Id de l'adresse à désactiver
         */
        removeAdress(params){
            let addressid = params.addressId;
            dataService.deleteClientAccountAddress(this.activeObj.id, addressid)
            .then((response) => {
                if(response.statusText == 'OK')
                {
                    let addressList = response.data.data.addressList
                    this.activeObj.addressList = this.$CObj(addressList);
                    //bus.$emit('updateList', {addressList: addressList});
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        /**
         * Désactive un contact
         * @param {Object} params - Id du contact à désactiver
         */
        removeContact(params){
            let contactId = params.contactId;
            if(this.activeObj.id == 0) { 
                let contactList = this.$CObj(this.activeObj.contactList)
                _.remove(contactList, {contactId:contactId })

                this.activeObj.contactList = contactList
                //bus.$emit('updateContactList', {contactList: this.activeObj.contactList});
            }else {
                dataService.detachContactFromClient(this.activeObj.id,contactId)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        SocketioService.getSocket().emit('afterDelete', {action: 'afterDelete', storeName:'clientcontact', payload: {id:contactId, isActive:false}});
                        let contactList = response.data.data.contactList
                        this.activeObj.contactList = this.$CObj(contactList);
                        //bus.$emit('updateContactList', {contactList: contactList});
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            }
        },
        /**
         * Enregistre un nouveau contact
         * @param {Object} params - nouveau contact
         */
        saveNewContact(params){
            let newContact = params.newContact;
            if(this.activeObj.id > 0) {
                dataService.addClientContact(newContact)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        const savedContact = response.data.data
                        SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'clientcontact', payload: savedContact});
                        return savedContact
                    }
                })
                .then((contact) => {
                    dataService.attachContactToClient(this.activeObj.id, {contactId : contact.id})
                        .then((response) => {
                            if(response.statusText == 'OK')
                            {
                                let contactList = response.data.data.contactList
                                this.activeObj.contactList = this.$CObj(contactList);
                                //bus.$emit('updateContactList', {contactList: contactList});
                                this.sendMsg2 ='Save new Contact OK';
                            }
                        })
                        .catch(error => {
                            this.sendMsg2 = error;
                        });
                })
                .catch(error => {
                    this.sendMsg2 = error;
                });
            } else { //Ajouter un contact en mode ajout de client
                alert('TODO #1')
            }
        },
        /**
         * Enregistre les modificatios du contact
         * @param {Object} params - un contact
         */
        updateContact(params) {
            let contact = params.contact;
            if(this.activeObj.id > 0) {
                dataService.updateClientContact(contact)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        SocketioService.getSocket().emit('afterUpdate', {action: 'afterUpdate', storeName:'clientcontact', payload: contact});
                        dataService.getClientAccountContacts(this.activeObj.id)
                        .then((response) => {
                            if(response.statusText == 'OK')
                            {
                                let contactList = response.data.data.contactList
                                this.activeObj.contactList = this.$CObj(contactList);
                                //bus.$emit('updateContactList', {contactList: contactList});
                                this.sendMsg2 ='Update client account contact OK';
                            }
                        })
                        .catch(error => {
                            this.sendMsg2 = error;
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            } else { //Modifier une addresse en mode ajout de client
                alert('TODD #2')
            }
        },
        /**
         * Insére un contact existant dans la fiche fournisseur
         * @param {Object} params - Un contact existant
         */
        insertContact(params) {
            let contact = params.contact;
            if(this.activeObj.id == 0) { 
                let newContact = {contactId:contact.id }
                let contactList = this.$CObj(this.activeObj.contactList)
                
                //Ajouter l'objet du nouveau contact tout en s'assurant qu'il n y aura pas de doublons
                if (_.isEmpty(_.remove(contactList, newContact))) { 
                    contactList.push(newContact);
                } else { contactList.push(newContact); }

                this.activeObj.contactList = contactList
                //bus.$emit('updateContactList', {contactList: this.activeObj.contactList});
            }
            else {
                dataService.attachContactToClient(this.activeObj.id, {contactId : contact.id})
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        //SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'clientcontact', payload: contact});
                        let contactList = response.data.data.contactList
                        this.activeObj.contactList = this.$CObj(contactList);
                        //bus.$emit('updateContactList', {contactList: contactList});
                        this.sendMsg2 ='Insert new Contact OK';
                    }
                })
                .catch(error => {
                    this.sendMsg2 = error;
                });
            }
        }

    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTmpClient2','getAllData']),
        /**
         * Vérifie s'il ya des modifications
         */
        checkAllField() {
            if(this.activeObj.addressList && this.activeObj.addressList.length == 1 && this.activeObj.addressList[0].id == 0) return true
            return JSON.stringify(this.originalObj) === JSON.stringify(this.activeObj)
        },
        /**
         * Vérifie si on autorise la désactivation du client
         */
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
        payload : () => store.getters.getClients,
        /**
         * Retourne la liste des clients du payload
         */
        //clientList() {return this.payload?.data?.client ? this.payload.data.client : [] },
        /**
         * Retourne la liste des clients du payload
         */
        //clientGroupList() {return this.payload?.data?.clientGroupe ? this.payload.data.clientGroup : []},
         /**
         * Retourne la liste des clients du payload
         */
        //escompteList() {return this.payload?.data?.escompte ? this.payload.data.escompte : []},
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() //charger les licences   
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                //this.loadApi()
            }
        },
        
        'activeObj.isCompany': function(newValue, oldValue) {
            this.activeObj.isParticular = oldValue
        }
        
    }
}
</script>

<style lang="scss" scoped>

.test{
    height: 200px;
}

.Commission{
    width: 35%;
    margin-left: 15px;
    margin-top: $sTopSpace;
}
.convertList{
    width: 100%;
    margin-left: 0px;
    margin-top: $sTopSpace;
}

</style>